var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlasses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#94eaff",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 465.478 465.478",
    xmlSpace: "preserve",
    stroke: "#94eaff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M455.478,212.239h-12.486c-5.002-46.316-44.33-82.496-91.953-82.496s-86.952,36.18-91.954,82.496h-52.692 c-5.002-46.316-44.33-82.496-91.954-82.496s-86.951,36.18-91.953,82.496H10c-5.523,0-10,4.477-10,10s4.477,10,10,10h12.486 c2.687,24.878,15.277,46.828,33.738,61.821l-17.74,26.044c-3.109,4.564-1.93,10.785,2.635,13.894 c1.723,1.174,3.682,1.736,5.621,1.736c3.197,0,6.339-1.53,8.274-4.371l18.007-26.437c12.468,6.271,26.537,9.809,41.418,9.809 c47.624,0,86.952-36.18,91.954-82.496h52.692c5.002,46.316,44.33,82.496,91.954,82.496c14.882,0,28.951-3.538,41.418-9.809 l18.007,26.437c1.936,2.841,5.077,4.371,8.274,4.371c1.938,0,3.897-0.563,5.62-1.736c4.565-3.109,5.745-9.33,2.635-13.894 l-17.74-26.044c18.461-14.993,31.052-36.943,33.738-61.821h12.486c5.523,0,10-4.477,10-10S461.001,212.239,455.478,212.239z M351.039,149.743c36.58,0,66.901,27.239,71.789,62.496H279.835h-0.586C284.137,176.982,314.458,149.743,351.039,149.743z M114.439,149.743c36.581,0,66.902,27.239,71.79,62.496h-0.586H42.649C47.538,176.982,77.859,149.743,114.439,149.743z M42.649,232.239H113.7c-16.937,10.21-31.75,24.052-43.226,40.9l-2.939,4.314C54.296,266.189,45.149,250.267,42.649,232.239z M114.439,294.735c-10.707,0-20.869-2.352-30.024-6.536l2.589-3.801c22.247-32.66,59.121-52.159,98.639-52.159h0.586 C181.341,267.496,151.02,294.735,114.439,294.735z M351.039,294.735c-36.581,0-66.902-27.239-71.79-62.496h0.586 c39.518,0,76.392,19.499,98.639,52.159l2.589,3.801C371.908,292.384,361.746,294.735,351.039,294.735z M397.942,277.453 l-2.939-4.314c-11.476-16.848-26.289-30.689-43.226-40.9h71.051C420.329,250.267,411.182,266.189,397.942,277.453z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlasses);
export default __webpack_public_path__ + "static/media/glasses.8d571ea595fa1a187c684a6145a36c4d.svg";
export { ForwardRef as ReactComponent };